/*
 * cma-journal-cards.js
 *
 * Blog articles contain plain fallback links: <a href="/products/HANDLE"><img ...><span>Title</span></a>
 * That plain link is what search engines and no-JS visitors see, so it must stay valid.
 *
 * On the live page this script fetches templates/product.journal-card.liquid for each
 * one and swaps in the real catalogue product card, so blog cards match the rest of
 * the store (live price, rating, quick add).
 *
 * If anything fails it leaves the fallback link untouched. That is correct behaviour.
 */
(function () {
  'use strict';

  var ROOT =
    document.querySelector('[data-cma-article]') ||
    document.querySelector('.article-template__content') ||
    document.querySelector('.article-content') ||
    document.querySelector('article .rte');

  if (!ROOT || !window.fetch || !window.DOMParser) return;

  var ROOTPATH = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var links = Array.prototype.filter.call(ROOT.querySelectorAll('a[href*="/products/"]'), function (a) {
    // A card is a product link wrapping an image.
    // data-cm-shop / data-cm-pill are the older CarMoods button styles - leave those alone.
    return (
      a.querySelector('img') &&
      !a.hasAttribute('data-cma-skip') &&
      !a.hasAttribute('data-cm-shop') &&
      !a.hasAttribute('data-cm-pill')
    );
  });

  if (!links.length) return;

  function cardUrl(href) {
    var clean = href.split('#')[0].split('?')[0];
    // Respect market/locale path prefixes (e.g. /en-au/products/...)
    if (clean.charAt(0) === '/' && ROOTPATH !== '/' && clean.indexOf(ROOTPATH) !== 0) {
      clean = ROOTPATH.replace(/\/$/, '') + clean;
    }
    return clean + '?view=journal-card';
  }

  // Any stylesheet the card fragment asks for needs to exist in <head>, not inline
  // in the article body, or it will not apply to sibling cards.
  function hoistStyles(doc) {
    var sheets = doc.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < sheets.length; i++) {
      var href = sheets[i].getAttribute('href');
      if (href && !document.querySelector('link[rel="stylesheet"][href="' + href + '"]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    }
  }

  // Preserve the sizing the fallback link carried, so grid rows do not reflow.
  // These marker substrings are written by the blog skill - if you change them
  // there, change them here and in assets/section-blog-post.css.
  function inheritLayout(oldEl, newEl) {
    var s = oldEl.getAttribute('style') || '';
    newEl.classList.add('cma-jcard-slot');
    if (s.indexOf('flex:1 1 160px') > -1) {
      newEl.classList.add('cma-jcard-slot--grid');
    } else if (s.indexOf('align-items:center') > -1) {
      newEl.classList.add('cma-jcard-slot--wide');
    }
  }

  links.forEach(function (a) {
    fetch(cardUrl(a.getAttribute('href')), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'fetch' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('[data-journal-card]');
        if (!card || !a.parentNode) return;
        hoistStyles(doc);
        inheritLayout(a, card);
        a.parentNode.replaceChild(card, a);
      })
      .catch(function () {
        /* leave the styled fallback link in place */
      });
  });
})();
